import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { I18n } from 'react-polyglot';
import messages from './translations';

import Footer from './components/instore/Footer';
import Header from './components/instore/Header';

import Page from './components/instore/Page';
import MainButton from './components/instore/MainButton';
import Introduction from './components/instore/Introduction';
import WeatherWidget from './components/instore/WeatherWidget';
import SkinAnalysisWidget from './components/instore/SkinAnalysisWidget';
import NextPageButton from './components/instore/NextPageButton';
import DarkButton from './components/instore/DarkButton';
import Questions from './components/instore/Questions';
import QuestionGender from './components/instore/QuestionGender';

import SelfieInstructions from './components/instore/SelfieInstructions';
import Selfie from './components/instore/Selfie';
import { SdkRenderContainer, SdkRenderContainerForAnalysis } from './components/instore/SdkRenderContainer';
import Progressbar from './components/instore/Progressbar';
import Products from './components/instore/Products';
import SecondNav from './components/instore/SecondaryNav';
import ProductDetails from './components/instore/ProductDetails';
import FilterButtons from './components/instore/ProductFilterButtons';
import SwipeGesture from './components/instore/SwipeGesture';
import ProductFilters from './components/instore/ProductFilters';
import ShareButton from './components/instore/ShareButton';
import SkinAnalysisWarningsWidget from './components/instore/SkinAnalysisWarningsWidget';
import LiveAR from './components/instore/LiveAR';
import ActionsWidget from './components/instore/ActionsWidget';

import { user_id } from './AppConf';

import {
  mergeDeep,
  inStoreIconSetup,
  findSkintypeFromFilters,
  converProductColorToRGB,
  getFinishFromProduct,
  getCoverageFromProduct,
} from './utils';

import { HashRouter as Router, Route, Switch } from 'react-router-dom';

import RevieveSDK from '@revieve/sdk';
import ApiCom from './services/ApiCom';

// Mapping of component name strings (used in the backend conf) to real
// react components
const ISComponentMapping = {
  is_mainbutton: MainButton,
  is_introduction: Introduction,
  is_nextpagebutton: NextPageButton,
  is_darkbutton: DarkButton,
  is_selfie_intructions: SelfieInstructions,
  is_selfie: Selfie,
  is_questions: Questions,
  is_questiongender: QuestionGender,
  is_analysis: SdkRenderContainerForAnalysis,
  is_arview: SdkRenderContainer,
  is_productdetails: ProductDetails,
  isw_weather: WeatherWidget,
  isw_skinanalysis: SkinAnalysisWidget,
  isw_skinanalysiswarnings: SkinAnalysisWarningsWidget,
  isw_progress: Progressbar,
  isw_products: Products,
  isw_actions: ActionsWidget,
  is_filterbuttons: FilterButtons,
  is_secondnav: SecondNav,
  is_swipegestureicon: SwipeGesture,
  is_productfilters: ProductFilters,
  is_sharebutton: ShareButton,
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      skinanalysis: {
        focusOn: null,
        data: {},
      },
      filters: {},
      apiCom: new ApiCom(),
      revieveConfig: props.revieveConfig,
      firstTimeSkinAnalysisPage: true,
      currentPageIndex: null,
      footerMinimized: false,
      footerVisible: true,
    };
  }

  componentWillMount = () => {
    this.initializeSDK();
  };

  initializeSDK = () => {
    const { apiCom, revieveConfig } = this.state;
    apiCom
      .getPluginConfig(revieveConfig.partnerId, revieveConfig.environment)
      .then(config => {
        let revieveSDK;
        if (!revieveConfig.environment) {
          revieveSDK = new RevieveSDK(revieveConfig.partnerId);
        } else {
          revieveSDK = new RevieveSDK(revieveConfig.partnerId, false, revieveConfig.environment);
        }
        revieveSDK.setUserId(user_id);
        revieveSDK.setApiVersion('' + config.results.cvApiVersion);
        let components = [
          'eyes',
          'wrinkles',
          'redness',
          'hyperpigmentation',
          'texture',
          'smoothness',
          'makeup',
          'masks',
          'wrinkles_visualization',
          'hyperpigmentation_visualization',
          'shine',
          'shine_visualization',
          'acne',
          'acne_visualization',
        ];
        revieveSDK.setConfiguration({ components });
        revieveSDK.setMatchToSkintoneCategories(['Foundation', 'Concealer']);
        const mergedMessages = mergeDeep({}, messages, config.translation);
        var locale = mergedMessages.hasOwnProperty(revieveConfig.locale) ? revieveConfig.locale : 'en';
        this.setState({
          config,
          sdk: revieveSDK,
          translatedMessages: mergedMessages[locale],
          pricegroup: this.getLastPriceGroupElement({ config }),
        });
      })
      .catch(error => {
        console.error(error);
      });
  };

  triggerCallback = ({ callback, payload }) => {
    const {
      onPageChange,
      onRetakeSelfie,
      onDisplayProducts,
      onImageAnalysisFinished,
      onFetchProducts,
      onChangePriceGroup,
      onAction,
      onChangeFilter,
    } = this.state.revieveConfig;
    switch (callback) {
      case 'pageChange':
        if (onPageChange && typeof onPageChange === 'function') onPageChange(payload.index, payload.name, payload.url);
        break;
      case 'retakeSelfie':
        if (onRetakeSelfie && typeof onRetakeSelfie === 'function') onRetakeSelfie();
        break;
      case 'displayProducts':
        if (onDisplayProducts && typeof onDisplayProducts === 'function') onDisplayProducts(payload);
        break;
      case 'imageAnalysisFinished':
        if (onImageAnalysisFinished && typeof onImageAnalysisFinished === 'function') onImageAnalysisFinished(payload);
        break;
      case 'fetchProducts':
        if (onFetchProducts && typeof onFetchProducts === 'function') onFetchProducts(payload);
        break;
      case 'changePriceGroup':
        if (onChangePriceGroup && typeof onChangePriceGroup === 'function') onChangePriceGroup(payload);
        break;
      case 'action':
        if (onAction && typeof onAction === 'function') onAction(payload);
        break;
      case 'changeFilter':
        if (onChangeFilter && typeof onChangeFilter === 'function') onChangeFilter(payload);
        break;
      default:
        break;
    }
  };

  getLastPriceGroupElement = ({ config }) => {
    const priceGroups = Object.keys(
      (config.results && config.results.priceGroups && config.results.priceGroups.default) || {},
    );
    return priceGroups[priceGroups.length - 1];
  };

  setPriceGroup = pricegroup => {
    this.triggerCallback({ callback: 'changePriceGroup', payload: pricegroup });
    this.setState({ pricegroup: pricegroup, footerMinimized: false });
  };

  focusOnSkinFinding = (focusOn, data, ranges) => {
    let { containerId } = this.state;
    if (!containerId) return;
    let focusOnConfiguration = inStoreIconSetup[focusOn];
    if (
      (!this.state.dragging && containerId && focusOnConfiguration && focusOnConfiguration.sdkMethod) ||
      focusOn === 'reset' ||
      this.state.firstTimeSkinAnalysisPage
    ) {
      if (focusOn === this.state.skinanalysis.focusOn || focusOn === 'reset') {
        this.state.sdk.AR.dehighlightAll().then(animation => {
          this.setState({
            ARAnimation: animation.out,
          });
        });
      } else {
        this.state.sdk.AR.dehighlightAll().then(() => {
          this.state.sdk.AR[focusOnConfiguration.sdkMethod](ranges).then(animation => {
            if (focusOnConfiguration.zoom) {
              this.setState({
                ARAnimation: animation.in,
              });
            } else {
              this.setState({
                ARAnimation: {
                  transform: 'rotate(0deg) translate3d(0px, 0px, 0px) scale(1)',
                  transformOrigin: 'center center',
                  transition: 'all 1s ease-in-out',
                },
              });
            }
          });
        });
      }
    }
    if (!this.state.dragging || focusOn === 'reset' || this.state.firstTimeSkinAnalysisPage) {
      if (focusOn === 'reset' || focusOn === this.state.skinanalysis.focusOn) {
        this.setState({
          skinanalysis: {
            focusOn: null,
            data: {},
          },
        });
      } else {
        this.setState({
          skinanalysis: {
            focusOn: focusOn,
            data: data,
          },
        });
      }
    } else {
      console.log('dragging!!');
    }
  };

  setDrag = boolean => {
    if (this.state.dragging === boolean) {
      return;
    }
    this.setState({ dragging: boolean, footerMinimized: false });
  };

  setFooterVisible = visible => this.setState({ footerVisible: visible });

  showProductDetails = product => {
    if (this.state.footerMinimized) {
      this.setState({ footerMinimized: false });
    } else {
      if (!this.state.dragging) {
        this.setState({ selectedProduct: product });
      }
    }
  };

  showTryOn = product => {
    const { sdk, filters } = this.state;
    let takeOff = false;
    if (!this.state.dragging) {
      let selectedProductsForTryOn = Object.assign({}, this.state.selectedProductsForTryOn);
      if (selectedProductsForTryOn.hasOwnProperty(product.category)) {
        if (selectedProductsForTryOn[product.category].id === product.id) {
          // toggle
          delete selectedProductsForTryOn[product.category];
          takeOff = true;
        } else {
          //  switch product for this category
          selectedProductsForTryOn[product.category] = product;
        }
      } else {
        // set product for this category
        selectedProductsForTryOn[product.category] = product;
      }
      if (takeOff) {
        if (sdk.liveAR.mounted) {
          let effectConfiguration = {};
          effectConfiguration[product.category.toLowerCase()] = { enabled: false };
          sdk.liveAR.changeEffects(effectConfiguration);
        } else {
          sdk.AR.visualizeProduct(product, 0);
        }
      } else {
        if (sdk.liveAR.mounted) {
          let effectConfiguration = {};
          effectConfiguration[product.category.toLowerCase()] = {
            enabled: true,
            color: converProductColorToRGB({ product }),
            finish: getFinishFromProduct({ product }),
          };
          if (product.category === 'Foundation') {
            effectConfiguration[product.category.toLowerCase()].coverage = getCoverageFromProduct({
              product,
              filters,
              mode: 'liveAR',
            });
          }
          sdk.liveAR.changeEffects(effectConfiguration);
        } else {
          if (product.category === 'Foundation') {
            sdk.AR.visualizeProduct(product, getCoverageFromProduct({ product, filters, mode: 'AR' }));
          } else {
            sdk.AR.visualizeProduct(product);
          }
        }
      }
      this.setState({ selectedProductsForTryOn: selectedProductsForTryOn, footerMinimized: !takeOff });
    }
  };

  closeProductDetails = () => {
    this.setState({ selectedProduct: null });
  };

  fetchProducts = () => {
    // we need to set all the filters value to the sdk
    const { filters, sdk } = this.state;
    let filtersMergedWithOptions = filters;
    if (this.state.config.results.filters) {
      filtersMergedWithOptions = { ...filters, ...this.state.config.results.filters };
    }

    // Regimen management
    let regimen;
    if (this.state.config.categories.hasOwnProperty('regimen')) {
      var skinType = findSkintypeFromFilters(this.state.filters);
      if (skinType) {
        regimen = this.state.config.categories.regimen[skinType.replace('_skin_ui', '_skin')];
      }
    }

    // Set filter values to SDK and fetch products
    let categoriesSettedByRegimen = false;
    for (const filter in filtersMergedWithOptions) {
      if (filtersMergedWithOptions.hasOwnProperty(filter)) {
        const value = filtersMergedWithOptions[filter];
        if (filter === 'requiredTags') {
          for (const requiredTagKey in value) {
            if (value.hasOwnProperty(requiredTagKey)) {
              const requiredTagValue = value[requiredTagKey];
              sdk.setCustomAttribute(requiredTagKey, requiredTagValue > 0 ? true : false, true);
            }
          }
        } else {
          sdk.setCustomAttribute(filter, value);
        }
        // regimen categories are more imporntant than general categories
        if (regimen && filter === 'requiredTags') {
          for (const requiredTagKey in value) {
            if (value.hasOwnProperty(requiredTagKey)) {
              const requiredTagValue = value[requiredTagKey];
              if (requiredTagValue > 0) {
                sdk.setCategories(regimen[requiredTagKey]);
              }
            }
          }
        } else if (regimen && regimen[filter] && value > 0) {
          sdk.setCategories(regimen[filter]);
          categoriesSettedByRegimen = true;
        } else if (!categoriesSettedByRegimen && this.state.config.categories && this.state.config.categories[value]) {
          sdk.setCategories(this.state.config.categories[value]);
        }
      }
    }
    if (this.state.config.results.priceGroups) {
      sdk.setCustomAttribute('priceGroups', this.state.config.results.priceGroups);
    }
    this.setState({
      products: {},
      loadingProducts: true,
      footerMinimized: false,
    });
    this.triggerCallback({ callback: 'fetchProducts', payload: sdk.getConfiguration() });
    try {
      sdk.PR.getRecommendedProducts()
        .then(products => {
          this.setState({
            products,
            loadingProducts: false,
            regimen,
          });
        })
        .catch(error => {
          console.log(error);
        });
      //RevieveActions.fetchResults(true);
    } catch (e) {
      console.log(e);
    }
  };

  analyzeImage = (image, skintone) => {
    const { sdk } = this.state;
    sdk.setSkintone(skintone);
    sdk.CV.setImage(image).then(() => {
      sdk.CV.analyzeImage()
        .then(() => {
          this.setState({ sdkCVState: sdk.CV.getState() });
          this.triggerCallback({ callback: 'imageAnalysisFinished', payload: sdk.CV.getResults() });
        })
        .catch(() => {
          console.error('Error processing image');
          this.setState({ sdkCVState: sdk.CV.getState() });
          this.triggerCallback({ callback: 'imageAnalysisFinished', payload: sdk.CV.getResults() });
        });
    });
  };

  setContainer = containerId => {
    const { sdk } = this.state;
    sdk.AR.setContainer(containerId);
    this.setState({ containerId });
  };

  renderInitialImage = containerId => {
    const { sdk } = this.state;
    sdk.AR.setContainer(containerId);
    this.setState({ containerId });
    sdk.AR.reset();
    // we need to apply an initial effect to render image in container
    sdk.AR.reduceEyebags(0).catch(() => {});
  };

  getSdkSkintone = () => {
    const { sdk } = this.state;
    return sdk.getSkintone();
  };

  canVisualizeProduct = product => {
    const { sdk } = this.state;
    return sdk.AR.canVisualizeProduct(product);
  };

  // navigate to next page
  nextPage = (currentIndex, history) => {
    if (currentIndex + 1 >= this.state.config.pages.length) {
      console.warn('already on the last page.');
    } else {
      this.triggerCallback({
        callback: 'pageChange',
        payload: {
          index: currentIndex + 1,
          name: this.state.config.pages[currentIndex + 1].name,
          url: this.state.config.pages[currentIndex + 1].url,
        },
      });
      if (this.state.config.pages[currentIndex + 1].url === '/recommendations' && this.state.skinanalysis.focusOn) {
        // if we hava a finding highlight we need to dehighlight before continue
        this.state.sdk.AR.dehighlightAll().then(animation => {
          this.setState(
            {
              ARAnimation: animation.out,
              skinanalysis: { focusOn: null, data: {} },
              footerMinimized: false,
              footerVisible: true,
            },
            () => {
              let url = this.state.config.pages[(currentIndex + 1) % this.state.config.pages.length].url;
              setTimeout(() => history.push(url), 1000);
            },
          );
        });
      } else {
        let url = this.state.config.pages[(currentIndex + 1) % this.state.config.pages.length].url;
        this.setState({ footerMinimized: false });
        history.push(url);
      }
    }
  };

  // navigate to previous page
  prevPage(currentIndex, history) {
    this.triggerCallback({
      callback: 'pageChange',
      payload: {
        index: currentIndex - 1,
        name: this.state.config.pages[currentIndex - 1].name,
        url: this.state.config.pages[currentIndex - 1].url,
      },
    });
    const currentPageConfig = this.state.config ? this.state.config.pages[currentIndex] : null;
    const prevPageConfig = this.state.config ? this.state.config.pages[currentIndex - 1] : null;
    const cleanSelectedProductsForTryOn = !currentPageConfig.liveARMode || !prevPageConfig.liveARMode;
    if (cleanSelectedProductsForTryOn) {
      this.setState({ selectedProductsForTryOn: {}, footerMinimized: false, footerVisible: true });
    } else {
      this.setState({ footerMinimized: false, footerVisible: true });
    }
    history.push(this.state.config.pages[(currentIndex - 1) % this.state.config.pages.length].url);
  }

  startOver(history) {
    this.triggerCallback({ callback: 'pageChange', payload: { index: 0, name: 'start page', url: '/' } });
    this.setState({
      filters: [],
      selectedProductsForTryOn: {},
      sdkCVState: null,
      ARAnimation: null,
      firstTimeSkinAnalysisPage: true,
      footerVisible: true,
    });
    this.initializeSDK();
    //RevieveActions.clearUI();
    history.push(this.state.config.pages[0].url);
  }

  toggleFilter = (key, value, componentFilters, multiSelect, autoAdvance, nextPageFn, root, getProducts = false) => {
    const { sdk } = this.state;
    let filters;
    if (root) {
      filters = Object.assign({}, this.state.filters[root]);
    } else {
      filters = Object.assign({}, this.state.filters);
    }

    // If the component is not multiselect, go through filters and remove all
    // componentFilters from previously set filters
    if (!multiSelect) {
      for (let f of componentFilters) {
        if (f === key) {
          continue;
        }
        if (typeof f !== 'object') filters[f] = 0;
      }
    }

    if (key === 'gender_ui') {
      sdk.setGender(value);
    }
    filters[key] = value;

    if (filters.hasOwnProperty(key) && autoAdvance && nextPageFn) {
      setTimeout(() => {
        nextPageFn();
      }, 400);
    }

    if (root) {
      let rootfilters = Object.assign({}, this.state.filters);
      rootfilters[root] = filters;
      this.setState({ filters: rootfilters }, () => {
        if (getProducts) {
          this.fetchProducts();
        }
      });
    } else {
      this.setState({ filters: filters }, () => {
        if (getProducts) {
          this.fetchProducts();
        }
      });
    }
  };

  hasMapping = componentSpec => {
    let hasMapping;
    if (typeof componentSpec === 'object') {
      hasMapping = ISComponentMapping.hasOwnProperty(componentSpec.name);
    } else {
      hasMapping = ISComponentMapping.hasOwnProperty(componentSpec);
    }
    if (!hasMapping) {
      console.warn('Not a Revieve component type: ' + JSON.stringify(componentSpec));
    }
    return hasMapping;
  };
  setSkinAnalysisPageRendered = () => {
    this.setState({
      firstTimeSkinAnalysisPage: false,
    });
  };

  getComponent = componentSpec => {
    let reactComponent;
    if (typeof componentSpec === 'object') {
      reactComponent = ISComponentMapping[componentSpec.name];
    } else {
      reactComponent = ISComponentMapping[componentSpec];
    }
    return reactComponent;
  };

  // builds a page and it's route from page config
  buildPage(page, i) {
    // Only try to render components that have a mapping
    let availableComponents = page.components.filter(component => {
      return this.hasMapping(component);
    });

    // widgets
    let footerWidgets;
    if (page.footer && page.footer.widgets) {
      let availableWidgets = page.footer.widgets.filter(widget => {
        return this.hasMapping(widget);
      });

      footerWidgets = availableWidgets.map((widget, wi) => {
        return React.createElement(this.getComponent(widget), {
          key: wi,
        });
      });
    }

    return (
      <Route
        key={i}
        exact
        path={page.url}
        render={props => (
          <Page
            nextPage={() => {
              this.nextPage(i, props.history);
            }}
            prevPage={() => {
              this.prevPage(i, props.history);
            }}
            startOver={() => {
              this.startOver(props.history);
            }}
            header={page.header}
            footer={Object.assign({}, page.footer, { widgets: footerWidgets })}
            name={page.name}
            style={page.style}
            cameraBackground={this.doINeedCameraBackgroud(page)}
            liveARMode={page.liveARMode}
            imageBackground={page.imageBackground}
            components={availableComponents.map((component, ci) => {
              // This one maps the component name strings into actual React
              // classes using the ISComponentMapping
              let reactComponent = this.getComponent(component);

              // NEXT LINE IS A MEGAHACK, TOO TIRED TO WRESTLE MORE TODAY.
              // The Header gets wrong history unless we save it here to InStoreApp
              // It baffles my mind to no end.
              this.history = props.history;

              // Here we instantiate them as React elements so
              // Page can just render the whole array.
              return React.createElement(reactComponent, {
                key: ci,
                selectedProduct: this.state.selectedProduct,
                closeProductDetails: this.closeProductDetails,
                selectedProductsForTryOn: this.state.selectedProductsForTryOn,
                cvResults: this.state.sdkCVState,
                routeProps: props,
                nextPage: () => {
                  this.nextPage(i, props.history);
                },
                prevPage: () => {
                  this.prevPage(i, props.history);
                },
                startOver: () => {
                  this.startOver(props.history);
                },
                filters: this.state.filters,
                toggleFilter: this.toggleFilter,
                options: typeof component === 'object' ? component : null,
                configOptions: this.state.config,
                focusedOnSkinFinding: this.state.skinanalysis.focusOn,
                focusOnSkinFinding: this.focusOnSkinFinding,
                setPriceGroup: this.setPriceGroup,
                pricegroup: this.state.pricegroup,
                products: this.state.products,
                regimen: this.state.regimen,
                fetchProducts: this.fetchProducts,
                analyzeImage: this.analyzeImage,
                ARAnimation: this.state.ARAnimation,
                ARMethods: {
                  renderInitialImage: this.renderInitialImage,
                },
                selfieInstructions: this.props.revieveConfig.selfieInstructions,
                setFooterVisible: this.setFooterVisible,
                sdk: this.state.sdk,
                triggerCallback: this.triggerCallback,
              });
            })}
          />
        )}
      />
    );
  }

  findPageConfig = location => {
    if (this.state.config && this.state.config.pages) {
      return this.state.config.pages.findIndex(page => {
        return page.url === location.pathname;
      });
    }
  };

  createProgressWidget = (page, index) => {
    if (page.footer && page.footer.progress && this.hasMapping(page.footer.progress)) {
      return React.createElement(this.getComponent(page.footer.progress), {
        key: 'progress',
        activePage: index - 1,
        pageCount: this.state.config.pages.length,
      });
    } else {
      return null;
    }
  };

  createFooterWidgets = (page, index) => {
    // widgets
    let footerWidgets;
    if (page.footer && page.footer.widgets) {
      let availableWidgets = page.footer.widgets.filter(widget => {
        return this.hasMapping(widget);
      });

      footerWidgets = availableWidgets.map((widget, wi) => {
        return React.createElement(this.getComponent(widget), {
          key: wi,
          activePage: index - 1,
          pageCount: this.state.config.pages.length,
          showProductDetails: this.showProductDetails,
          selectedProductsForTryOn: this.state.selectedProductsForTryOn,
          showTryOn: this.showTryOn,
          cvResults: this.state.sdkCVState,
          focusOnSkinFinding: this.focusOnSkinFinding,
          focusedOnSkinFinding: this.state.skinanalysis.focusOn,
          setSkinAnalysisPageRendered: this.setSkinAnalysisPageRendered,
          filters: this.state.filters,
          products: this.state.products,
          loadingProducts: this.state.loadingProducts,
          pricegroup: this.state.pricegroup,
          currency: this.state.config.currency,
          options: widget,
          configOptions: this.state.config,
          revieveConfig: this.state.revieveConfig,
          setLat: lat => this.state.sdk.setLat(lat),
          setLon: lon => this.state.sdk.setLon(lon),
          ARMethods: {
            canVisualizeProduct: this.canVisualizeProduct,
            visualizeProduct: this.visualizeProduct,
            getSdkSkintone: this.getSdkSkintone,
          },
          defaultLocation: this.props.revieveConfig.defaultLocation,
          triggerCallback: this.triggerCallback,
        });
      });
    }
    return footerWidgets;
  };

  doINeedCameraBackgroud = pageConfig => pageConfig.background && pageConfig.background === 'camera';

  /* eslint react/display-name: "off" */
  render = () => {
    return (
      <div>
        {this.state.translatedMessages && (
          <I18n locale={this.state.revieveConfig.locale || 'en'} messages={this.state.translatedMessages}>
            <Router history={this.props.history} ref={router => (this.router = router)}>
              <Route
                path="/"
                onChange={this.onNavigate}
                render={({ location }) => {
                  let pageIndex = this.findPageConfig(location);
                  let pageConfig = this.state.config ? this.state.config.pages[pageIndex] : null;
                  let headerConfig = this.state.config && this.state.config.header ? this.state.config.header : null;
                  return (
                    <div className="rootWrapper">
                      {this.state.config && (
                        <div>
                          {this.doINeedCameraBackgroud(pageConfig) && <Selfie isBackground={true} />}
                          {pageConfig.liveARMode && <LiveAR sdk={this.state.sdk} />}
                          <ReactCSSTransitionGroup
                            transitionName="headerSlide"
                            transitionAppear={false}
                            transitionEnter={true}
                            transitionLeave={true}
                            transitionAppearTimeout={900}
                            transitionLeaveTimeout={900}
                            transitionEnterTimeout={900}
                          >
                            {pageConfig.header ? (
                              <Header
                                pageIndex={pageIndex}
                                key={'header'}
                                headerConfig={headerConfig}
                                navigation={pageConfig.header.navigation}
                                navigationText={pageConfig.header.navigationText}
                                startOver={() => {
                                  this.startOver(this.history);
                                }}
                                prevPage={() => {
                                  this.prevPage(pageIndex, this.history);
                                }}
                              />
                            ) : null}
                          </ReactCSSTransitionGroup>

                          <Switch location={location}>
                            {this.state.config.pages.map((page, i) => {
                              return this.buildPage(page, i);
                            })}
                          </Switch>

                          <Footer
                            setDrag={this.setDrag}
                            visible={pageConfig.footer && !this.state.selectedProduct && this.state.footerVisible}
                            minimized={this.state.footerMinimized}
                            pageIndex={pageIndex}
                            rootElement={this.props.root}
                            key={'footer'}
                            filters={this.state.filters}
                            pricegroup={this.state.pricegroup}
                            {...Object.assign(
                              {},
                              pageConfig.footer,
                              { widgets: this.createFooterWidgets(pageConfig, pageIndex) },
                              { progress: this.createProgressWidget(pageConfig, pageIndex) },
                            )}
                          />
                        </div>
                      )}
                    </div>
                  );
                }}
              />
            </Router>
          </I18n>
        )}
      </div>
    );
  };
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js